export default __webpack_public_path__ + "static/Hawker-800a-e6b7499cbf5c6e79fc84731c25ba525d.jpg";